export default "__VITE_ASSET__3512cc72__"